// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 647 ? "second" : chunkId) + "." + {"647":"9f0619ef","979":"480b2be1"}[chunkId] + ".js";
};